import { getRumInstance } from 'src/rum';
import { logger } from 'src/logger';

/**
 * Emits a named event to all observability backends.
 * Fans out to AWS RUM (as a custom event) and Katal logger.
 *
 * Baseline context (timestamp, route) is attached automatically.
 * Feature code calls this for workflow lifecycle events:
 *   emit('audit.perform.started', { auditId })
 *   emit('task.perform.completed', { taskId, durationMs })
 */
export function emit(name: string, payload?: Record<string, unknown>): void {
  const event = {
    name,
    timestamp: Date.now(),
    route: window.location.pathname,
    ...payload,
  };

  // Log structured event
  logger.info(`[event] ${name}`, event);

  // Record in RUM as custom event
  getRumInstance().then((rum) => {
    rum?.recordEvent(name, event);
  });
}
